<script setup lang="ts">
const contentStore = useContentStore();
const { filteredTermsAndConditions } = classToRefs(contentStore);
</script>
<template>
    <div>
        <div
            v-for="term in filteredTermsAndConditions"
            :key="term.id"
            class="root"
            dir="rtl"
            v-html="term.body"
        />
    </div>
</template>

<style lang="scss" scoped>
.root {
    text-align: justify;
    padding: 10px;

    :deep() {
        h2 {
            color: usePalette();
        }
        li {
            display: list-item;
        }

        ol {
            display: block;
            list-style: decimal;
            margin: 1em 0;
            padding-right: 40px;
        }

        ul {
            display: block;
            list-style: disc;
            margin: 1em 0 1em;
            padding-right: 40px;
        }
    }
}
</style>
